/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Instagram_HandleInputs */

const en_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@instagram_handle`)
};

const es_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@usuario_instagram`)
};

const fr_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@pseudo_instagram`)
};

const de_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@instagram_handle`)
};

const ja_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@instagram_handle`)
};

const zh_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@instagram_handle`)
};

const ar_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@instagram_handle`)
};

const id_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@handle_instagram`)
};

const it_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@nome_instagram`)
};

const ru_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@instagram_handle`)
};

const pt_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@usuario_instagram`)
};

const ko_instagram_handle = /** @type {(inputs: Instagram_HandleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@instagram_handle`)
};

/**
* | output |
* | --- |
* | "@instagram_handle" |
*
* @param {Instagram_HandleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const instagram_handle = /** @type {((inputs?: Instagram_HandleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Instagram_HandleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_instagram_handle(inputs)
	if (locale === "es") return es_instagram_handle(inputs)
	if (locale === "fr") return fr_instagram_handle(inputs)
	if (locale === "de") return de_instagram_handle(inputs)
	if (locale === "ja") return ja_instagram_handle(inputs)
	if (locale === "zh") return zh_instagram_handle(inputs)
	if (locale === "ar") return ar_instagram_handle(inputs)
	if (locale === "id") return id_instagram_handle(inputs)
	if (locale === "it") return it_instagram_handle(inputs)
	if (locale === "ru") return ru_instagram_handle(inputs)
	if (locale === "pt") return pt_instagram_handle(inputs)
	return ko_instagram_handle(inputs)
});